/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios'
import { API_ENDPOINTS } from 'constants'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  saveMultiImage: (data) => {
    return axios.post(API_ENDPOINTS.MULTI_IMAGE_UPLOAD, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
}
